import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const MessageIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <path
                    d="M16.5,7.9V2.2h-16v11.1h4.9v2.8l2.2-2.2V19h8.3l2.8,2.8V19h4.9V7.9H16.5z M7.5,12.6l-1.1,1.1v-0.5v-1h-1H1.5
		V3.1h14v9.2H8.2H7.8L7.5,12.6z M22.5,18.1h-3.9h-1v1v0.5l-1.1-1.1l-0.3-0.3h-0.4H8.5v-4.8h8V8.9h6.1V18.1z"
                />
            </g>
        </SvgIcon>
    );
};
